import { render, staticRenderFns } from "./MonthlyIncomeGraph.vue?vue&type=template&id=60faff36&scoped=true"
import script from "./MonthlyIncomeGraph.vue?vue&type=script&lang=js"
export * from "./MonthlyIncomeGraph.vue?vue&type=script&lang=js"
import style0 from "./MonthlyIncomeGraph.vue?vue&type=style&index=0&id=60faff36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60faff36",
  null
  
)

export default component.exports